import { Box, Typography, Button } from '@mui/material';
import { ReactNode } from 'react';
import { Inbox, Search, FilterList, AddCircleOutline } from '@mui/icons-material';
import { colors } from '../../theme/theme';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  type?: 'default' | 'search' | 'filter';
}

export const EmptyState = ({
  icon,
  title,
  description,
  action,
  type = 'default',
}: EmptyStateProps) => {
  // Default icons based on type
  const getDefaultIcon = () => {
    switch (type) {
      case 'search':
        return <Search sx={{ fontSize: 80 }} />;
      case 'filter':
        return <FilterList sx={{ fontSize: 80 }} />;
      default:
        return <Inbox sx={{ fontSize: 80 }} />;
    }
  };

  const displayIcon = icon || getDefaultIcon();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: colors.grey[50],
          color: colors.grey[300],
          mb: 3,
          '& svg': {
            fontSize: 80,
          },
        }}
      >
        {displayIcon}
      </Box>

      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: '1.125rem',
          color: colors.grey[900],
          mb: 1,
        }}
      >
        {title}
      </Typography>

      {/* Description */}
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: colors.grey[600],
            fontSize: '0.875rem',
            lineHeight: 1.6,
            maxWidth: 400,
            mb: action ? 3 : 0,
          }}
        >
          {description}
        </Typography>
      )}

      {/* Action Button */}
      {action && (
        <Button
          variant="contained"
          size="large"
          startIcon={<AddCircleOutline />}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </Box>
  );
};
